module.exports = __webpack_public_path__ + "resources/icon_44_comment.e960eb56ca142cbf.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_comment.png
// module id = 348
// module chunks = 0 1 2 3 4